module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Christianity "), _c('br'), _vm._v("as the Moral Order of "), _c('br'), _vm._v("Integration")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-one-introduction"
    }
  }, [_vm._v("Chapter One: Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-two-the-segregation-of-heaven-from-earth-and-the-creation-of-human-beings"
    }
  }, [_vm._v("Chapter Two: The Segregation of Heaven from Earth and the ‘Creation’ of Human Beings")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#the-babylonian-myth-of-creation"
    }
  }, [_vm._v("The Babylonian Myth of Creation")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-three-the-creation-of-the-human-being-genesis-2"
    }
  }, [_vm._v("Chapter Three: The Creation of the Human Being Genesis 2")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-four-the-moral-order-of-separation-genesis-3"
    }
  }, [_vm._v("Chapter Four: The Moral Order of Separation Genesis 3")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-five-the-primordial-world-of-homo-sapiens-and-the-cleansing-flood"
    }
  }, [_vm._v("Chapter Five: The Primordial World of Homo Sapiens and the Cleansing Flood")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#genesis-411"
    }
  }, [_vm._v("Genesis 4–11")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-six-a-cleansed-creation-a-new-beginning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: A Cleansed Creation: A New Beginning")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-city-tower-of-babel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The City-Tower of Babel")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-seven-the-beginning-of-the-history-of-israel-abram-and-sarai",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: The Beginning of the History of Israel Abram and Sarai")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#genesis-1224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genesis 12–24")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-eight-isaac-and-jacob-the-continuation-of-the-journey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: Isaac and Jacob The Continuation of the Journey")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#genesis-2538",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genesis 25–38")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#esau-and-jacob",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Esau and Jacob")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-nine-joseph-in-egypt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Joseph in Egypt")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#genesis-3950",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genesis 39–50")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-ten-enslavement-in-egypt-and-gods-liberation-of-israel-by-moses",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Enslavement in Egypt and God’s Liberation of Israel by Moses")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#exodus-214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exodus 2–14")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-eleven-moses-and-the-exodus-journey-of-israel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: Moses and the Exodus Journey of Israel")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#exodus-15-numbers-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exodus 15-Numbers 24")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-twelve-the-blessings-of-balaam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: The Blessings of Balaam")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#numbers-2224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Numbers 22–24")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-thirteen-the-dilemma-of-kingship-and-hierarchical-rule",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: The Dilemma of Kingship and Hierarchical Rule")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#samuel-11-kings-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Samuel 1—1 Kings 1")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chaptcer-fourteen-the-prologue-of-isaiah-separation-and-integration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen: The Prologue of Isaiah Separation and Integration")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#isaiah-1146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 1:1–4:6")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#the-journey-of-the-nations-to-jerusalem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Journey of the Nations to Jerusalem")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-fifteen-the-parable-of-the-vineyard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: The Parable of the Vineyard")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#isaiah-5130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 5:1–30")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-sixteen-the-call-and-commission-of-isaiah",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen: The Call and Commission of Isaiah")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#isaiah-6113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 6:1–13")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-seventeen-isaiah-the-end-of-kingship-and-the-rise-of-the-immanuel-community",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen: Isaiah, the End of Kingship, and the Rise of the Immanuel Community")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#isaiah-71818",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 7:1–8:18")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-eighteen-the-turn-toward-universality",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen The Turn Toward Universality")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#isaiah-1323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 13–23")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#the-burden-of-babylon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Burden of Babylon")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#the-burden-of-yahweh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Burden of Yahweh")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-nineteen-the-apocalypse-of-isaiah-2426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen: The Apocalypse of Isaiah 24–26")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#isaiah-2426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 24–26")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#the-apocalypse-of-isaiah-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Apocalypse of Isaiah 27")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-twenty-second-isaiah-the-new-things-of-yahweh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty: Second Isaiah: The “New Things” of Yahweh")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#isaiah-4055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 40–55")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-first-servant-poem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Servant Poem")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-second-servant-poem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Servant Poem")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-third-servant-poem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third Servant Poem")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-fourth-servant-poem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fourth Servant Poem")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-twenty-one-third-isaiah-the-opposition-between-the-prophets-and-the-priests",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One: Third Isaiah: The Opposition Between the Prophets and the Priests")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#the-zadokite-priesthood-and-its-restoration-ideology",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Zadokite Priesthood and Its Restoration Ideology")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-twenty-two-the-book-of-the-watchers-book-1-of-i-enoch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two: The Book of the Watchers: Book 1 of I Enoch")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-twenty-three-the-collapse-of-israel-as-a-theocracy-the-context-of-daniel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three: The Collapse of Israel as a Theocracy: The Context of Daniel")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-twenty-four-the-apocalypse-of-daniel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four: The Apocalypse of Daniel")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-twenty-five-the-testament-of-naphtali",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five: The Testament of Naphtali")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-twenty-six-john-the-baptist",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six: John the Baptist")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-twenty-seven-jesus-of-nazareth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven: Jesus of Nazareth")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#mark-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mark 1–15")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-twenty-eight-the-ending-of-the-gospel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight: The Ending of the Gospel")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#mark-1618",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mark 16:1–8")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-twenty-nine-the-apostle-paul-and-the-completion-of-abrahams-journey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine: The Apostle Paul and the Completion of Abraham’s Journey")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-thirty-the-ontological-reality-of-the-resurrection-of-jesus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty: The Ontological Reality of the Resurrection of Jesus")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#corinthians-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Corinthians 15")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#primary-sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primary Sources")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#reference-works",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reference Works")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#secondary-sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Secondary Sources")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0